import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box, Typography } from '@mui/material';
import { getAllOperators, type QueryOperator } from '@/utils/query-builder';

export interface OperatorSelectorProps {
  value?: QueryOperator;
  onChange: (operator: QueryOperator | null) => void;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
}

export const OperatorSelector: React.FC<OperatorSelectorProps> = ({
  value,
  onChange,
  disabled = false,
  error = false,
  helperText,
  size = 'small'
}) => {
  const availableOperators = getAllOperators();
  
  return (
    <FormControl fullWidth size={size} disabled={disabled} error={error}>
      <InputLabel>Operator</InputLabel>
      <Select
        value={value || ''}
        onChange={(e) => onChange(e.target.value as QueryOperator || null)}
        label="Operator"
        renderValue={(selected) => {
          const operator = availableOperators.find(op => op.value === selected);
          return operator?.label || '';
        }}
      >
        {availableOperators.map((op) => (
          <MenuItem key={op.value} value={op.value}>
            <Box>
              <Typography variant="body2" fontWeight="medium">
                {op.label}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {op.description}
              </Typography>
            </Box>
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <Typography variant="caption" color={error ? 'error' : 'text.secondary'} sx={{ mt: 0.5, ml: 1.75 }}>
          {helperText}
        </Typography>
      )}
    </FormControl>
  );
};
